import React from 'react';
import { Button } from '../ui/Button';
export function StickyFooter() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 shadow-2xl md:hidden z-50" data-id="element-187">
      <div className="flex items-center justify-between gap-4" data-id="element-188">
        <div data-id="element-189">
          <p className="text-xs text-gray-500 line-through" data-id="element-190">Normal: $580</p>
          <p className="text-xl font-bold text-emerald-700" data-id="element-191">$290 UYU</p>
        </div>
        <Button onClick={scrollToOffer} size="md" className="flex-1" data-id="element-192">
          Descargar Ahora
        </Button>
      </div>
    </div>;
}